<template>
  <div class="card-structure-symabio">
    <div class="container">
      <div class="div">
        <div class="frame" style="background-image: url('/CA/TAHINA RANDRIARILALA.webp');" />
        <p class="p">
          <span class="text-wrapper">
            Tahina RANDRIARILALA
            <br />
          </span>
          <span class="span">
            Présidente
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/ANDRDANDRAINA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Andrandraina RASOLONJATOVO
            <br />
          </span>
          <span class="span">
            Vice-président
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/OLIVIER NIRINA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Nirina Olivier RAKOTOSON
            <br />
          </span>
          <span class="span">
            Vice-président
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/SANDRA RANDRIANARISOA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Sandra RANDRIANARISOA
            <br />
          </span>
          <span class="span">
            Secrétaire Générale
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/HERVE GAUDICHE.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Hervé GAUDICHE
            <br />
          </span>
          <span class="span">
            Trésorier
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/FALY RASAMIMANANA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Falimananjratsoa RASAMIMANANA
            <br />
          </span>
          <span class="span">
            Trésorier Adjoint
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Patrick COLLIN
            <br />
          </span>
          <span class="span">
            Conseiller
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/ZO HARIJAONA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Zo Harijaona RANDRIANANTENAINA
            <br />
          </span>
          <span class="span">
            Conseiller
          </span>
        </p>
      </div>
      <div class="div">
        <div class="frame" style="background-image: url('/CA/FABIOLA JULIA.webp');" />
        <p class="description-2">
          <span class="text-wrapper-3">
            Julia FABIOLA
            <br />
          </span>
          <span class="span">
            Conseillère
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardStructureSymabio",
};
</script>

<style>
.card-structure-symabio {
  align-items: flex-start;
  display: inline-flex;
  gap: 10px;
  /* left: 619px; */
  /* overflow-y: scroll; */
  /* padding: 10px; */
  width: 48vw;
  margin: 12vh 0px;
  /* position: absolute; */
  /* top: 35px; */
}

.card-structure-symabio .container {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 8px;
  /* height: 718px; */
  position: relative;
  /* width: 688px; */
}

.card-structure-symabio .div {
  align-items: flex-start;
  align-self: stretch;
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  padding: 20px;
  position: relative;
  width: 30%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(59, 114, 62, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-structure-symabio .div:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-structure-symabio .frame {
  align-self: stretch;
  background-color: #f8f9fa;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(https://static.vecteezy.com/system/resources/thumbnails/024/983/914/small/simple-user-default-icon-free-png.png);
  height: 160px;
  position: relative;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(59, 114, 62, 0.2);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.card-structure-symabio .p {
  align-self: stretch;
  color: #2c3e50;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.card-structure-symabio .text-wrapper {
  font-weight: 600;
  color: #2c3e50;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.card-structure-symabio .span {
  font-family: "Mona-Sans-Light", Helvetica;
  font-weight: 400;
  color: #59734a;
  font-size: 13px;
}

.card-structure-symabio .description-2 {
  align-self: stretch;
  color: #2c3e50;
  font-family: "Mona-Sans-Bold", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.card-structure-symabio .text-wrapper-3 {
  font-weight: 600;
  color: #2c3e50;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.card-structure-symabio::-webkit-scrollbar {
  display: none;
  width: 0;
}
@media (max-width:1200px){
  .card-structure-symabio  {
    width: -webkit-fill-available;
    margin: 0 auto;
  }
  .card-structure-symabio .container {
    justify-content: center;
  }
}

/* Enhanced Mobile Responsive Design */
@media (max-width: 768px) {
  .card-structure-symabio {
    width: 100%;
    margin: 6vh 0px;
  }
  
  .card-structure-symabio .container {
    gap: 16px;
    padding: 0 16px;
  }
  
  .card-structure-symabio .div {
    width: calc(50% - 8px);
    padding: 16px;
    gap: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  
  .card-structure-symabio .frame {
    height: 140px;
    border-radius: 8px;
  }
  
  .card-structure-symabio .p,
  .card-structure-symabio .description-2 {
    font-size: 13px;
    line-height: 20px;
    text-align: center;
  }
  
  .card-structure-symabio .text-wrapper,
  .card-structure-symabio .text-wrapper-3 {
    font-size: 13px;
    font-weight: 600;
    display: block;
    word-wrap: break-word;
    hyphens: auto;
  }
  
  .card-structure-symabio .span {
    font-size: 12px;
    display: block;
    margin-top: 4px;
    color: #3b723e;
  }
}

/* Mobile Portrait - Very Small Screens */
@media (max-width: 480px) {
  .card-structure-symabio .container {
    gap: 12px;
    padding: 0 12px;
  }
  
  .card-structure-symabio .div {
    width: 100%;
    padding: 16px;
    margin-bottom: 0;
  }
  
  .card-structure-symabio .frame {
    height: 150px;
  }
  
  .card-structure-symabio .p,
  .card-structure-symabio .description-2 {
    font-size: 14px;
    line-height: 22px;
  }
  
  .card-structure-symabio .text-wrapper,
  .card-structure-symabio .text-wrapper-3 {
    font-size: 14px;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  
  .card-structure-symabio .span {
    font-size: 13px;
  }
}
</style>